import { Panel, Table } from '@/components/Bicester';
import { Cell } from '@/components/Bicester/Table';
import { DateTimeCell, ShoppingVillageCell } from '@/components/Bicester/Table/Cells';
import useRouter from '@/hooks/useRouter';
import useTable from '@/hooks/useTable';
import { fetchConvertTicketList } from '@/services/account';
import options from '@/utils/options';
import { useRequest } from 'ahooks';
import React from 'react';

const ExchangeRecord = () => {
  const { match, query } = useRouter<{ id: string }>();

  const {
    run: getRecordList,
    data: { content_list: recordListData, current_page, total } = {},
    loading: recordListLoading,
  } = useRequest(fetchConvertTicketList, {
    manual: true,
  });

  const { onChange, onSearch } = useTable(async (p) => {
    const params = Object.assign({}, p, {
      member_id: match.params.id,
    });
    await getRecordList(params);
  });

  return (
    <Panel
      title="兑换记录"
      expanded
      defaultExpand={false}
      onExpand={(expanded) =>
        expanded &&
        !recordListData?.length &&
        getRecordList({ page: 1, member_id: match.params.id })
      }
      subTitle={`总计 ${total || 0} 条`}
    >
      <Table
        pageInfo={{ page: current_page, total }}
        data={recordListData ?? []}
        loading={recordListLoading}
        columns={[
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '兑换购物村',
            cell: <ShoppingVillageCell dataKey="shopping_village" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '卡券类型',
            cell: (
              <Cell dataKey="image_type">
                {(rowData) => {
                  const { image_type } = rowData;
                  return options(
                    {
                      1: () => '现金券',
                      2: () => '打折券',
                      3: () => '体验券',
                      4: () => '礼品券',
                      5: () => '餐饮券',
                    },
                    image_type
                  );
                }}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '兑换时间',
            cell: <DateTimeCell dataKey="scan_time" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '卡券名',
            cell: <Cell dataKey="name" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '兑换方式',
            cell: (
              <Cell dataKey="type">
                {(rowData) => {
                  const { type } = rowData;
                  return options(
                    {
                      1: () => '自动兑换',
                      2: () => '手动兑换',
                    },
                    type
                  );
                }}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '兑换人',
            cell: <Cell dataKey="gift_member_name" />,
          },
        ]}
        onChange={onChange}
      >
        <Table.Body isEmptyHoverBody={false} />
        <Table.Pagination />
      </Table>
    </Panel>
  );
};

export default ExchangeRecord;
